// ============================================================
// RECURRING TASK HYDRATOR
//
// Translates database objects into BluPrint objects.
//
// Database names remain here.
// The UI should consume BluPrint names only.
// ============================================================

import { formatRecurrencePattern } from '../utils/recurrenceUtils'

import {
  relation,
  summary
} from './common'

console.log('Recurring hydrator loaded')

export function hydrateRecurringTask(task) {

  // ----------------------------------------------------------
  // Primary relationships
  // ----------------------------------------------------------

  const recurrenceType = relation(task.recurrence_types)
  const priority = relation(task.priority_levels)
  const taskTime = relation(task.task_times)
  const status = relation(task.status_levels)
  const project = relation(task.projects)
  const context = relation(task.context)
  const focusArea = relation(task.focus_area)
  const location = relation(task.locations)
  const timeOfDay = relation(task.time_of_day_levels)
  const impact = relation(task.impact_levels)
  const capacity = relation(task.capacity_levels)
  const dayType = relation(task.day_type_levels)

  // ----------------------------------------------------------
  // Display values
  // ----------------------------------------------------------

  const recurrenceSummary = summary(
    formatRecurrencePattern(task)
  )

  // ----------------------------------------------------------
  // BluPrint concepts
  // ----------------------------------------------------------

  const isDaily = recurrenceType?.name === 'Daily'
  const isWeekly = recurrenceType?.name === 'Weekly'
  const isMonthly = recurrenceType?.name === 'Monthly'
  const isYearly = recurrenceType?.name === 'Yearly'

  const isSeasonal =
    recurrenceType?.name === 'Seasonal'

  const isInterval =
    recurrenceType?.name === 'Interval'

  const isCalendar =
    recurrenceType?.name === 'Calendar Dates'

  const isKeepUntilDone =
    task.keep_until_done === true

  const hasProject = !!project
  const hasContext = !!context
  const hasLocation = !!location

  // ----------------------------------------------------------
  // BluPrint object
  // ----------------------------------------------------------

  return {
    ...task,

    recurrenceType,

    priority,
    taskTime,
    status,
    project,
    context,
    focusArea,
    location,
    timeOfDay,
    impact,
    capacity,
    dayType,

    summary: recurrenceSummary,

    isDaily,
    isWeekly,
    isMonthly,
    isYearly,

    isSeasonal,
    isInterval,
    isCalendar,
    isKeepUntilDone,

    hasProject,
    hasContext,
    hasLocation
  }
}

export function hydrateRecurringTasks(tasks = []) {
  return tasks.map(hydrateRecurringTask)
}